import { UserManagement } from '../components/UserManagement';

export function AdminUsersPage() {
  return <UserManagement />;
}